<div class="logo-main">
  <a routerLink="/">
    <svg>
      <use [attr.xlink:href]="logo" [attr.href]="logo"></use>
    </svg>
  </a>
</div>
